var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "dummy-page-summary" }, [
    _c("div", { staticClass: "card-block" }, [
      _c("div", { staticClass: "page-header-section" }, [
        _c("div", { staticClass: "row" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-content-section" }, [
        _c("div", { staticClass: "row" }),
        _vm._v(" "),
        _c("div", { staticClass: "row" })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a32be02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a32be02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DummyPageSummary.vue
// module id = oIH6
// module chunks = 1